export const Types = {
    LOAD_ALL_COUNTRIES: "LOAD_ALL_COUNTRIES_SUCCESS",
    TOGGLE_COUNTRY_SORT: "TOGGLE_COUNTRY_SORT",
    COUNTRY_GLOBAL_SEARCH: "COUNTRY_GLOBAL_SEARCH",
}

export const Detail = {
    LOAD_COUNTRY_DETAIL: "LOAD_ONE_COUNTRY_SUCCESS",
    CLEAR_COUNTRY_DETAIL_PAGE: "CLEAR_COUNTRY_DETAIL_PAGE",
}

export const CountrySortFields = {
    COUNTRY_NAME: "country_name",
    LAST_UPDATED: "last_updated",
}
